import config from '../config';

const AZURE_API_URL = `${config.pronvest.api.url}AzureAD`;
const REPORTS_API_URL = `${config.pronvest.api.url}Reports`;

export const getPlanSponsorSummaryReport = async (
  adminSession,
  planSponsorGuid
) => {
  const url = new URL(
    `${REPORTS_API_URL}/PlanSponsor/${planSponsorGuid}/Summary`
  );

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${adminSession.token.key}`,
      'Content-Type': 'application/json',
    },
  });

  if (res.ok) {
    // Only read the body once
    return await res.json();
  }

  // Error path: try to include server-provided details (still only read once)
  let details = '';
  try {
    details = await res.text();
  } catch {
    details = '';
  }

  switch (res.status) {
    case 401:
      throw new Error(
        "Authentication error, the user's identity can't be verified or the token is expired."
      );
    case 403:
      throw new Error(
        "Authorization error, the user most likely doesn't belong to the correct Azure admin group."
      );
    case 404:
      throw new Error(`Plan sponsor not found. GUID: ${planSponsorGuid}`);
    default:
      throw new Error(
        `API error (${res.status} ${res.statusText})${
          details ? `: ${details}` : ''
        }`
      );
  }
};

export const getHealthCheck = async (adminSession) => {
  const res = await fetch(`${AZURE_API_URL}/HealthCheck`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${adminSession.token.key}`,
      'Content-Type': 'application/json',
    },
  });

  return res;
};
